import { render, staticRenderFns } from "./SpecialEquipment.vue?vue&type=template&id=23941f60&scoped=true"
import script from "./SpecialEquipment.vue?vue&type=script&lang=js"
export * from "./SpecialEquipment.vue?vue&type=script&lang=js"
import style0 from "./SpecialEquipment.vue?vue&type=style&index=0&id=23941f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23941f60",
  null
  
)

export default component.exports